import React, { useState, useRef } from "react";
import { Modal, useModal } from "./../../../shared/Modal";

// Renders a video poster with a play button. Click opens a lightbox
// with controls. Used by widgets that want to show video proofs as
// thumbnails (Wall, Marquee, etc).
const MediaThumbnail = ({ proof, className = "", style, posterClassName = "" }) => {
  const { modalOpen, setModalOpen } = useModal();
  const videoRef = useRef(null);

  if (!proof.video_url) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className={`relative group cursor-pointer overflow-hidden ${className}`}
        style={style}
        aria-label={`Play video from ${proof.name || "customer"}`}
      >
        <video
          ref={videoRef}
          src={proof.video_url}
          muted
          playsInline
          preload="metadata"
          className={`w-full h-full object-cover ${posterClassName}`}
        />
        <span className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="bg-white/95 group-hover:bg-white text-black w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-transform group-hover:scale-110">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 ml-0.5">
              <path d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
            </svg>
          </span>
        </span>
      </button>

      <Modal modalOpen={modalOpen} setModalOpen={setModalOpen} icon="video" maxWidth="max-w-3xl">
        <div className="relative px-1 sm:px-4 pt-2 pb-4">
          {proof.headline && (
            <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-3 break-words pr-8">
              {proof.headline}
            </h2>
          )}
          <video
            controls
            autoPlay
            playsInline
            src={proof.video_url}
            className="w-full max-h-[70vh] bg-black rounded"
          />
          <div className="mt-3 flex items-center gap-2 text-sm text-slate-600">
            {proof.avatar && (
              <img src={proof.avatar} alt="" className="w-6 h-6 rounded-full object-cover" />
            )}
            <span className="font-bold">{proof.name}</span>
            {proof.contact_title && <span>· {proof.contact_title}</span>}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MediaThumbnail;
